module.exports = __webpack_public_path__ + "static/img/titzh-tw.6dbfe64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/entry/img/titzh-tw.png
// module id = 8fA0
// module chunks = 1